export function evaluateCondition(condition: string, config: Record<string, any>): boolean {
    const result = condition.match(/([a-zA-Z0-9_]+)\s*(!=|==|>|<)\s*(.+)/);
    if (!result) {
        const key = condition.trim();
        return !!config[key];
    }

    const [, key, op, rawValue] = result;
    const actualValue = config[key];

    let val: any = rawValue.trim();
    if (val === 'true') val = true;
    else if (val === 'false') val = false;
    else if (!isNaN(Number(val))) val = Number(val);
    else if (val.startsWith("'") && val.endsWith("'")) val = val.slice(1, -1);
    else if (val.startsWith('"') && val.endsWith('"')) val = val.slice(1, -1);

    switch (op) {
        case '==': return actualValue == val;
        case '!=': return actualValue != val;
        case '>': return actualValue > val;
        case '<': return actualValue < val;
        default: return false;
    }
}

export function resolveTemplate(
    template: string,
    config: Record<string, any>,
    valueResolver: (key: string, value: any) => string | null
): string | null {
    let result = template;

    // 1. Resolve ternaries FIRST
    const ternaryRegex = /\{([^?}{]+)\?\s*([\s\S]+?)\s*:\s*([\s\S]+?)\}/g;
    result = result.replace(ternaryRegex, (_match, cond, t, f) => {
        const isTrue = evaluateCondition(cond.trim(), config);
        return (isTrue ? t : f).trim().replace(/"/g, '');
    });

    // 2. Resolve ALL {key} variables into labels
    let hasError = false;
    const varRegex = /\{([a-zA-Z0-9_]+)\}/g;
    result = result.replace(varRegex, (match, key) => {
        const val = config[key];
        if (val === undefined) {
            // Skip optional/undefined keys rather than failing
            return '';
        }
        const resolved = valueResolver(key, val);
        if (resolved === null) {
            hasError = true;
            return match; // Placeholder; we'll abort anyway
        }
        return resolved;
    });

    if (hasError) return null;

    return result.trim().replace(/\s+/g, ' ');
}
